// extracted by mini-css-extract-plugin
export default {"borderRadiusSM":"4px","borderRadiusXXL":"24px"};